"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentAttributes$ = exports.AgentAttributes$outboundSchema = exports.AgentAttributes$inboundSchema = exports.Id$ = exports.Id$outboundSchema = exports.Id$inboundSchema = void 0;
exports.idToJSON = idToJSON;
exports.idFromJSON = idFromJSON;
exports.agentAttributesToJSON = agentAttributesToJSON;
exports.agentAttributesFromJSON = agentAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Id$inboundSchema = z.union([
    z.number(),
    z.string(),
]);
/** @internal */
exports.Id$outboundSchema = z
    .union([z.number(), z.string()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Id$;
(function (Id$) {
    /** @deprecated use `Id$inboundSchema` instead. */
    Id$.inboundSchema = exports.Id$inboundSchema;
    /** @deprecated use `Id$outboundSchema` instead. */
    Id$.outboundSchema = exports.Id$outboundSchema;
})(Id$ || (exports.Id$ = Id$ = {}));
function idToJSON(id) {
    return JSON.stringify(exports.Id$outboundSchema.parse(id));
}
function idFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Id$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Id' from JSON`);
}
/** @internal */
exports.AgentAttributes$inboundSchema = z.object({
    branch_name: z.string(),
    company_name: z.string(),
    id: z.nullable(z.union([z.number(), z.string()])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "branch_name": "branchName",
        "company_name": "companyName",
    });
});
/** @internal */
exports.AgentAttributes$outboundSchema = z.object({
    branchName: z.string(),
    companyName: z.string(),
    id: z.nullable(z.union([z.number(), z.string()])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        branchName: "branch_name",
        companyName: "company_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AgentAttributes$;
(function (AgentAttributes$) {
    /** @deprecated use `AgentAttributes$inboundSchema` instead. */
    AgentAttributes$.inboundSchema = exports.AgentAttributes$inboundSchema;
    /** @deprecated use `AgentAttributes$outboundSchema` instead. */
    AgentAttributes$.outboundSchema = exports.AgentAttributes$outboundSchema;
})(AgentAttributes$ || (exports.AgentAttributes$ = AgentAttributes$ = {}));
function agentAttributesToJSON(agentAttributes) {
    return JSON.stringify(exports.AgentAttributes$outboundSchema.parse(agentAttributes));
}
function agentAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AgentAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AgentAttributes' from JSON`);
}
//# sourceMappingURL=agentattributes.js.map